export enum InAppCreditsOwnerCtx {
  IACOwnerAccount = "account",
  IACOwnerUser = "user",
}

export enum InAppCreditsType {
  IACTypeMail = "mail",
}

export enum MailType {
  GuestInvite = "guestinvite",
  AccessCard = "accesscard",
  RsvpReminder = "rsvpreminder",
  Countdown = "countdown",
  ThankYouNote = "thankyounote",
}

export const MailTypeTextMap: Record<MailType, string> = {
  [MailType.GuestInvite]: "Wedding Invite",
  [MailType.AccessCard]: "Access Card",
  [MailType.RsvpReminder]: "RSVP Reminder",
  [MailType.Countdown]: "Countdown",
  [MailType.ThankYouNote]: "Thank You Note",
};

export const createDefaultInAppCredits = (): InAppCredits => ({
  _id: "",
  iacOwnerID: "",
  iacOwnerCtx: InAppCreditsOwnerCtx.IACOwnerAccount,
  iacType: InAppCreditsType.IACTypeMail,
  balance: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export type InAppCredits = {
  _id: string;
  iacOwnerID: string;
  iacOwnerCtx: InAppCreditsOwnerCtx;
  iacType: InAppCreditsType;
  balance: number;
  createdAt: Date;
  updatedAt: Date;
};

export type InAppPackage = {
  _id: string;
  name: string;
  credits: number;
  amount: number;
  createdAt: Date;
  updatedAt: Date;
};

export const createDefaultInAppPackage = (): InAppPackage => ({
  _id: "",
  name: "",
  credits: 0,
  amount: 0,
  createdAt: new Date(),
  updatedAt: new Date(),
});
